import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { clearToken } from "@/lib/auth";
import {
  LayoutDashboard, Building2, Leaf, Tags, Shirt, ListChecks, Activity,
  AlertOctagon, MessageSquare, FileText, ListOrdered, Settings, LogOut, Search, BarChart3, Bug, ShieldCheck,
} from "lucide-react";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/analytics", icon: BarChart3, label: "Analytics" },
  { to: "/admin/brands", icon: Building2, label: "Brands" },
  { to: "/admin/clothing-items", icon: Shirt, label: "Clothing items" },
  { to: "/admin/materials", icon: Leaf, label: "Materials" },
  { to: "/admin/materials-certifications", icon: Tags, label: "Materials certifications" },
  { to: "/admin/brand-certifications", icon: Tags, label: "Brand certifications" },
  { to: "/admin/clothing-types", icon: Tags, label: "Clothing types" },
  { to: "/admin/crawl-runs", icon: Activity, label: "Crawl runs" },
  { to: "/admin/reports", icon: AlertOctagon, label: "False ad reports" },
  { to: "/admin/contacts", icon: MessageSquare, label: "Contacts" },
  { to: "/admin/cms-pages", icon: FileText, label: "CMS pages" },
  { to: "/admin/navigation", icon: ListOrdered, label: "Navigation" },
  { to: "/admin/page-seo", icon: Search, label: "SEO" },
  { to: "/admin/errors", icon: Bug, label: "Error log" },
  { to: "/admin/gdpr", icon: ShieldCheck, label: "GDPR" },
  { to: "/admin/settings", icon: Settings, label: "Settings" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  function logout() {
    clearToken();
    navigate("/admin/login");
  }

  return (
    <div className="admin-theme min-h-screen flex bg-[#E9ECEF] font-admin text-[#212529]">
      <aside className="w-64 bg-white border-r border-[#E9ECEF] flex flex-col sticky top-0 h-screen self-start" data-testid="admin-sidebar">
        <Link to="/admin" className="px-5 py-5 border-b border-[#E9ECEF]">
          <div className="text-lg font-semibold">Sustainably Curated</div>
          <div className="text-xs text-[#6C757D]">Admin</div>
        </Link>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto" data-testid="admin-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) => `flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? "bg-[#212529] text-white" : "text-[#212529] hover:bg-[#F1F3F5]"}`}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <n.icon className="w-4 h-4" />
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} className="m-3 flex items-center gap-2 px-3 py-2 text-sm text-[#6C757D] border border-[#E9ECEF] rounded-md hover:bg-[#F1F3F5]" data-testid="admin-logout-button">
          <LogOut className="w-4 h-4" /> Log out
        </button>
      </aside>
      <main className="flex-1 overflow-x-auto">
        <div className="px-6 py-6 max-w-[1400px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
